import * as url from './url_helper';

// get Filter List
export const getFilterList = async () => {
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query{
        getFilterList(data: {
          userId: ${user.id || ''}})
          {
         name
         type
         data {
           id
           name
         }
       }
     }`;

  // return get(url.GET_FILTER_LIST)
  // const res = post(url.GET_FILTER_LIST, data)
  // return res

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.getFilterList;
};

// get Orders
// export const getFilterData = () => get(url.GET_FILTER_DATA)
// export Interface FilterData

export function getNames(list: []) {
  const listNames = list.map((obj: any) => {
    return `{name: "${obj.label}"}`;
  });
  return listNames.join();
}

export const getFilterData = async (data: any) => {
  const { from, to, status, whLocation, comodityType, seller, brand, buyer } =
    data;

  const whLocationNames = getNames(whLocation);
  const comodityTypeNames = getNames(comodityType);
  const sellerNames = getNames(seller);
  const brandNames = getNames(brand);
  const buyerNames = getNames(buyer);
  const statusNames = getNames(status);

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
  getFilterData(data: 
    {
      userId: ${user.id || ''},
      startDate: "${from || ''}",
      endDate: "${to || ''}",
      status: [ ${statusNames} ],      
      whLocation: [ ${whLocationNames} ],
      comodityType: [${comodityTypeNames}],
      seller: [${sellerNames}],
      brand: [${brandNames}],
      buyer: [${buyerNames}]
    })
    {
    sales {
      id
      title
      price
      isDoller
      postFix
      statusColor
      series
    }
    salesByLocation {
      id
      title
      percent
      value
      quantity
      latLng
    }
    amountOrdesBrand {
      series
      labels
      colors
    }
    orders {
      id
      key
      title
      price
      isDoller
      postFix
      statusColor
      series
      colors
      labels
    }
    ordersByCommodity {
      labels
      Profit
      Loss
      colors
    }
    recentActivity {
      id  
      name
      symbol
      symbolColor
      dateTime
      value
    }
  }
}
  `;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.getFilterData[0];
};
